import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CompareContext = createContext(null);
const STORAGE_KEY = "hv_compare_ids";

const readStorage = () => {
  if (typeof window === "undefined") return [];
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

export function CompareProvider({ children }) {
  const [selected, setSelected] = useState(readStorage);

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(selected));
  }, [selected]);

  const value = useMemo(
    () => ({
      selected,
      toggleCompare: (id) => {
        setSelected((prev) =>
          prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        );
      },
      removeCompare: (id) =>
        setSelected((prev) => prev.filter((item) => item !== id)),
      clearCompare: () => setSelected([]),
    }),
    [selected]
  );

  return (
    <CompareContext.Provider value={value}>
      {children}
    </CompareContext.Provider>
  );
}

export const useCompare = () => {
  const ctx = useContext(CompareContext);
  if (!ctx) {
    throw new Error("useCompare must be used inside CompareProvider");
  }
  return ctx;
};
